import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as brandsApi from '../api/brandsApi';
import * as api from '../api/modelsApi';
import * as types from '../constants/modelsConstants';
import { GET_MODELS_BRAND_REQUEST } from '../constants/modelsConstants';

export const getModelsActions = (search, brandId, unpaged) => async (dispatch) => {
  dispatch({ type: types.GET_MODELS_REQUEST });
  try {
    const { error, data } = await api.getModels(search, brandId, unpaged);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_MODELS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список моделей');
    dispatch({ type: types.GET_MODELS_FAILURE });
  }
};

export const getModelsBrand = (brandId) => async (dispatch) => {
  dispatch({ type: GET_MODELS_BRAND_REQUEST });
  try {
    const { error, data } = await brandsApi.getBrand(brandId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_MODELS_BRAND_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити модель');
    dispatch({ type: types.GET_MODELS_BRAND_FAILURE });
  }
};

export const updateModelAction = (model, brandId) => async () => {
  try {
    const { error } = await api.updateModel(model, brandId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити модель');
  }
};

export const createModelAction = (model, brandId) => async () => {
  try {
    const { error } = await api.createModel(model, brandId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати модель');
  }
};

export const deleteModelAction = (modelId, brandId) => async () => {
  try {
    const { error } = await api.deleteModel(modelId, brandId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Модель була успішно видалена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити модель');
  }
};

export const setModelBrandAction = (brand) => async (dispatch) => {
  dispatch({
    type: types.GET_MODELS_BRAND_SUCCESS,
    payload: brand,
  });
};

export const clearModelsActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_MODELS,
  });
};

export const clearModelsBrandActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_MODELS_BRAND,
  });
};

export const setModelsPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_MODELS_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setSelectedModelAction = (model) => async (dispatch) => {
  dispatch({
    type: types.SELECT_MODEL,
    payload: model,
  });
};

export const clearSelectedModelAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_MODEL,
  });
};

export const setModelsSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_MODELS_SEARCH,
    payload: search,
  });
};

export const nextModelsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_MODELS_PAGE,
  });
};

export const prevModelsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_MODELS_PAGE,
  });
};
